import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ImgFallbackModule } from 'ngx-img-fallback';

import { CommonAppModule } from '../../common/common-app.module';
import { PipeModule } from '../../common/pipes/pipe.module';
import { ProductsModule } from '../../pages/shared/products/products.module';
import { NotificationsModule } from '../../shared/notifications/notifications.module';
import { UiModule } from '../../ui/ui.module';
import { OtherBankNewCardComponent } from '../others/other-bank-new-card/other-bank-new-card.component';

import { LeftPanelComponent } from './left-panel/left-panel.component';
import { ProductBalanceComponentModule } from './product-balance/product-balance.module';
import { ProductFastMenuComponent } from './product-list/product-fast-menu/product-fast-menu.component';
import { ProductSliderComponent } from './product-list/product-slider/product-slider.component';
import { UserProductsComponent } from './user-products/user-products.component';


@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		ImgFallbackModule,
		RouterModule,
		ReactiveFormsModule,
		UiModule,
		DragDropModule,
		ProductBalanceComponentModule,
		NotificationsModule,

		ProductsModule,
		ProductFastMenuComponent,
		PipeModule,
	],
	exports: [
		LeftPanelComponent,
		OtherBankNewCardComponent,
		ProductFastMenuComponent,
		UserProductsComponent,
		ProductSliderComponent,
		ProductBalanceComponentModule,
	],
	declarations: [
		LeftPanelComponent,
		OtherBankNewCardComponent,
		UserProductsComponent,
		ProductSliderComponent,
	],
	providers: [],
})

export class LeftPanelModule { }
